<template>
  <v-app>
    <dashboard-core-app-bar />

    <dashboard-core-drawer />

    <dashboard-core-view class="zoom-" />

    <dashboard-core-settings />

    <toast position="se" />
  </v-app>
</template>

<script>
  import { S_TIMERECORD_ADDED } from '../../gql/timeReocrd'
  import moment from 'moment'
  import { Q_GET_TEAMS } from '@/gql/team'
  import { Q_GET_COMPANIES } from '@/gql/company'
  import { fetchAllGroups } from '@/helpers/tikApi'
  import { ADD_TOAST_MESSAGE, Toast } from 'vuex-toast'
  import {mapActions} from 'vuex'
  export default {
    name: 'DashboardIndex',

    components: {
      Toast,
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      DashboardCoreDrawer: () => import('./components/core/Drawer'),
      DashboardCoreSettings: () => import('./components/core/Settings'),
      DashboardCoreView: () => import('./components/core/View'),
    },

    data: () => ({
      expandOnHover: false,
    }),
    methods: {
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE,
      }),

      sendNotification (text) {
        this.addToast({
          text,
          type: 'success',
          dismissAfter: 10000,
        })
      },
    },
    async mounted () {
      const userAssignedGroups = this.$store.state.user?.groups || []
      
      try {
        const allGroups = await fetchAllGroups()
        if (allGroups?.length) {
          const groupsToShow = userAssignedGroups.length > 0 ? allGroups.filter(g => 
            userAssignedGroups.includes(typeof g === 'string' ? g : g.code || g.name)
          ) : allGroups
          this.$store.commit('SET_GROUPS', groupsToShow)
        }
      } catch (e) {
        console.log('failed to fetch groups')
      }

      const { data } = await this.$apollo.query({
        query: Q_GET_COMPANIES,
        variables: {
          where: {
            tenantId: localStorage.getItem('company'),
          },
        },
      })
      console.log({data})

      if (data && data.companies && data.companies[0] && data.companies[0].settings) {
        localStorage.setItem('companyFull', JSON.stringify(data.companies[0]))
        this.$store.commit('SET_COMPANY_FULL', data.companies[0])
      }

      try {
        let { workCloseDays } = await (await fetch('https://apis2.truwrk.com/dama_quat/workclosedays', { cache: 'no-store' })).json()
        // console.log(workCloseDays)


        if (workCloseDays) {
          if(data?.companies[0]?.workCloseDays?.length) {
            workCloseDays = workCloseDays.concat(data.companies[0].workCloseDays.map(wd=>moment(wd.date).format('M/D/YYYY')))
           // console.log(workCloseDays,)
          }

          this.$store.commit('SET_WORKCLOSEDAYS', workCloseDays)
        }
      } catch (e) {
        console.log('failed to get hollydays')
        // this.$store.commit('SET_WORKCLOSEDAYS', workCloseDays)
      }

      // this.$store.commit('SET_TEAMS', JSON.parse(localStorage.getItem('teams')))
      // // console.log('team', this.$store.state.team)
      // if (this.$store.state.roles && this.$store.state.roles.includes('head')) {
      //   this.$store.commit('SET_TEAMS', data.teams)
      //   this.$store.commit('SET_TEAM', data.teams[0] && data.teams[0].code)
      //   // console.log('team', this.$store.state.team)
      // }
    },
    apollo: {
      // $subscribe: {
      //   // When a user is added
      //   timeRecordAdded: {
      //     query: S_TIMERECORD_ADDED,
      //     // Result hook
      //     result ({ data }) {
      //       // console.log(new Date(data.timeRecordAdded.date).toDateString(),new Date().toDateString())
      //       if (new Date(data.timeRecordAdded.date).toDateString() === new Date().toDateString()) {
      //         this.$toast.info(`${data.timeRecordAdded.member.firstName} Clocked In at ${moment(data.timeRecordAdded.clockIn || new Date()).format('HH:mm')}`, {
      //           timeout: null,
      //           icon: 'mdi-account-arrow-left-outline',
      //           dismissable: false,
      //           queueable: true,
      //           showClose: true,
      //           iconColor: 'white', // default
      //           closeIcon: 'mdi-close', // default
      //         })
      //       }
      //       // this.$toasted.show(`${data.timeRecordAdded.member.fullName} Clocked In`, {
      //       //   theme: 'bubble',
      //       //   position: 'bottom-right',
      //       //   duration: null,
      //       //   icon: 'mdi-account-arrow-left-outline',
      //       // })
      //     //  console.log(data)
      //     // this.selected += data.timeRecordAdded
      //       // Let's update the local data
      //     //  this.online_list = data.data.online_users
      //     },
      //   },
      // },
    },
  }
</script>

<style>
/*.zoom- {*/
/*  zoom: 0.8;*/
/*  margin-left: 80px;*/
/*}*/
</style>
